import { createSelector } from '@reduxjs/toolkit';

import { GET_DEFAULT_CONSTRUCTOR } from '@/constants/constructor';
import type { ConstructorType } from '@/interfaces/constructor.interfaces';
import mergeGrid from '@/utils/mergeGrid';

import prepareConstructorGrid from '../helpers/prepareConstructorGrid';

import configSelector from './config';

/**
 * Получить конструктор
 */
const constructorSelector = createSelector(configSelector, ({ constructor }) => {
  return Object.entries(GET_DEFAULT_CONSTRUCTOR()).reduce(
    (acc, [page, pageConstructor]) => {
      const mergedGrid = mergeGrid(pageConstructor, constructor?.[page]);
      return {
        ...acc,
        [page]: prepareConstructorGrid(mergedGrid),
      };
    },
    {} as ConstructorType,
  );
});

export default constructorSelector;
